export default function DevDashboardHelp() {
  return (
    <>
      <p>
      This Dashboard is internal to the Application DevOps team which provides a view of all Failed processes per selected data. Select Start & End Date, then hit LOAD button. 
      </p>
    </>
  );
}
